import { zeroGridProStyles } from '@genesislcap/foundation-zero-grid-pro';
import { css, ElementStyles } from '@microsoft/fast-element';
import { boxSizing, scrollbarStyles } from '../../../styles';

export const customAgGridStyles: ElementStyles = css`
  ${zeroGridProStyles}
  ${scrollbarStyles}
  ${boxSizing}

  .ag-theme-genesis-rapid-dark {
    --ag-value-change-value-highlight-background-color: 'rgba(122, 204, 121, 0.55)';
  }

  .ag-theme-genesis-rapid-dark .ag-row-selected.ag-row {
    background-color: #344232;
  }

  .ag-set-filter-item-checkbox {
    height: 100%;
  }

  .ag-theme-genesis-rapid-dark .ag-checkbox-input-wrapper.ag-checked::after {
    color: #589b5b !important;
    background-color: white;
  }

  .ag-theme-genesis-rapid-dark .ag-header-cell,
  .ag-theme-genesis-rapid-dark .ag-cell {
    padding: 0 8px;
    font-size: 11px;
  }

  .ag-theme-genesis-rapid-dark .ag-ltr .ag-cell {
    display: flex;
  }

  .ag-cell-wrapper.ag-row-group {
    align-items: center;
  }

  .ag-theme-genesis-rapid-dark .ag-ltr .ag-group-child-count {
    display: none !important;
  }

  .ag-theme-genesis-rapid-dark .ag-row {
    font-size: 12px !important;
  }

  .ag-cell-wrapper {
    overflow: hidden;
  }

  .ag-theme-genesis-rapid-dark .ag-header-blue {
    border-bottom: 1px solid #7eaaff;
    background-color: rgb(126 170 255 / 10%);
    color: #7eaaff;
    text-align: center;
    line-height: normal;
  }

  .ag-theme-genesis-rapid-dark .ag-header-red {
    border-bottom: 1px solid #f9644d;
    background-color: rgb(249 100 77 / 10%);
    color: #f9644d;
    text-align: center;
    line-height: normal;
  }

  .ag-theme-genesis-rapid-dark .ag-header-gray {
    border-bottom: 1px solid #f2f2f2;
    background-color: rgb(242 242 242 / 10%);
  }

  .ag-header-group-text {
    width: 100%;
  }

  .ag-theme-genesis-rapid-dark .ag-row:has(.is-linked) {
    background-color: rgb(169 255 120 / 5%);
  }

  .ag-row:has(.is-linked) > * {
    opacity: 0.3;
  }

  .is-linked {
    flex-grow: 1;
  }

  .is-linked input.ag-checkbox-input {
    pointer-events: none;
  }

  .select-with-icon .ag-cell-wrapper {
    display: flex;
    flex: 1;
  }

  .select-with-icon .ag-cell-wrapper .ag-cell-value {
    flex: none;
  }

  .center-header .ag-header-cell-label {
    justify-content: center;
  }

  .ag-theme-genesis-rapid-dark .ag-row-selected.transparent-background {
    background-color: var(--ag-background-color);
  }

  .ag-theme-genesis-rapid-dark .ag-row-selected.transparent-background:hover {
    background-color: var(--ag-row-hover-color);
  }

  .ag-theme-genesis-rapid-dark .ag-checkbox-input-wrapper {
    line-height: 14px;
    font-size: 14px;
    width: 14px;
    height: 14px;
  }

  .ag-theme-genesis-rapid-dark .ag-checkbox-input-wrapper::after {
    color: #0000;
    border: 1px solid var(--ag-checkbox-unchecked-color, #999);
    border-radius: 4px;
  }

  .ag-theme-genesis-rapid-dark .ag-checkbox-input-wrapper input {
    width: 14px;
    height: 14px;
  }

  .ag-theme-genesis-rapid-dark .ag-checkbox-input-wrapper:active,
  .ag-theme-genesis-rapid-dark .ag-checkbox-input-wrapper:focus-within {
    box-shadow: none;
  }

  .ag-theme-genesis-rapid-dark .row-dark {
    background-color: black;
  }

  :host(.chevron-count) .ag-cell-wrapper.ag-row-group {
    align-items: center;
    display: flex;
    align-self: center;
    flex-direction: row-reverse;
    background: rgb(135 155 166 / 10%);
    border-radius: 2px;
    width: 31px;
    height: 22px;
  }

  :host(.chevron-count) .ag-theme-genesis-rapid-dark .ag-ltr .ag-group-contracted,
  :host(.chevron-count) .ag-theme-genesis-rapid-dark .ag-ltr .ag-group-expanded,
  :host(.chevron-count) .ag-theme-genesis-rapid-dark .ag-ltr .ag-row-drag,
  :host(.chevron-count) .ag-theme-genesis-rapid-dark .ag-ltr .ag-selection-checkbox {
    margin-right: 0;
  }

  :host(.chevron-count) .ag-theme-genesis-rapid-dark .ag-icon {
    color: #879ba6;
  }

  :host(.watch-list-grid) .ag-body-viewport.ag-layout-normal {
    overflow: hidden;
  }

  :host(.analytics-project-drilldown) .ag-row-selected .ag-cell {
    background-color: #262c2b;
  }

  :host(.no-row-action-button) .ag-overlay {
    pointer-events: auto;
  }

  .no-data-overlay-link {
    color: var(--primary-color);
    cursor: pointer;
  }
  .no-data-overlay-link:hover {
    text-decoration: underline;
  }

  .no-project-to-show {
    color: var(--primary-color);
  }

  .ag-floating-top {
    overflow: hidden !important;
  }
`;
